/* eslint-disable indent */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card } from 'react-bootstrap'
import PlayerAvatar from './PlayerAvatar'
import { decodeHtmlEntities, isOld, dateFin } from '../services/helpfunctions'
import { getInjuryBadge } from '../services/injury'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

const PlayerCardHeader = ({
  player,
  nation,
  ownerNation,
  actualAge,
  u21Badge,
  t,
  candidates,
  message,
}) => {
  const navigate = useNavigate()
  const countryCode = nation?.Country?.CountryCode?.toLowerCase()
  const flagUrl = countryCode
    ? `https://flagcdn.com/20x15/${countryCode}.png`
    : null

  // Omistajan maan lippu
  const ownerCountryCode = ownerNation?.Country?.CountryCode?.toLowerCase()
  const ownerFlagUrl = ownerCountryCode
    ? `https://flagcdn.com/20x15/${ownerCountryCode}.png`
    : null
  const injuryBadge = getInjuryBadge(player)

  // Pelaajan listat
  const playerLists = candidates
    ? candidates.filter(
        c =>
          Array.isArray(c.Players) &&
          c.Players.some(
            p => (p.player?.id || p.player?.toString()) === player.id
          )
      )
    : []
  const visibleLists = playerLists.slice(0, 3)
  const remainingCount = playerLists.length - 3

  return (
    <Card.Header
      style={{
        backgroundColor: '#1a1d21',
        color: '#FFFFFF',
        padding: '10px 15px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      {/* Avatar */}
      {player.avatar &&
        player.avatar.layers &&
        player.avatar.layers.length > 0 && (
          <PlayerAvatar avatar={player.avatar} size={80} />
        )}

      {/* Player info */}
      <div style={{ flex: 1 }}>
        {/* Row 1: Name, flag, heart, ID */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
            {player.firstName} {player.lastName}
          </span>
          {injuryBadge && (
            <span
              title={injuryBadge.title}
              style={{
                color: injuryBadge.icon === '❌' ? '#e74c3c' : '#f1c40f',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
              }}
            >
              {injuryBadge.text}
            </span>
          )}
          <a
            href={
              'https://hattrick.org/goto.ashx?path=/Club/Players/Player.aspx?playerId=' +
              player.playerId
            }
            target="_blank"
            rel="noreferrer"
            style={{ color: '#7289DA', textDecoration: 'none' }}
          >
            ({player.playerId})
          </a>
          {player.motherClubBonus === 1 && (
            <span
              style={{ color: '#e74c3c', fontSize: '1rem' }}
              title="Mother Club"
            >
              ❤️
            </span>
          )}
          {flagUrl && (
            <img
              src={flagUrl}
              alt={nation?.Country?.CountryName || ''}
              title={nation?.Country?.CountryName || ''}
              style={{ marginLeft: '2px' }}
            />
          )}
        </div>

        {/* Row 2: Age */}
        <div style={{ fontSize: '0.85rem', marginTop: '2px' }}>
          {t('age')}: {actualAge.years}.{actualAge.days}
          {u21Badge && (
            <span
              style={{
                marginLeft: '8px',
                padding: '1px 6px',
                borderRadius: '4px',
                backgroundColor: '#1a1a2e',
                color: u21Badge.color,
                fontSize: '0.8rem',
                fontWeight: 'bold',
              }}
            >
              {u21Badge.text}
            </span>
          )}
        </div>

        {/* Row 3: Owner team + arrival date + list memberships */}
        <div
          style={{
            fontSize: '0.85rem',
            marginTop: '2px',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '4px',
          }}
        >
          {ownerFlagUrl && (
            <a
              href={`https://hattrick.org/goto.ashx?path=/Club/Manager/?userId=${player.owningTeam?.ownerId}`}
              target="_blank"
              rel="noreferrer"
              title={ownerNation?.Country?.CountryName || ''}
            >
              <img
                src={ownerFlagUrl}
                alt={ownerNation?.Country?.CountryName || ''}
                style={{ marginRight: '4px' }}
              />
            </a>
          )}
          <a
            href={
              'https://hattrick.org/goto.ashx?path=/Club/?TeamID=' +
              player.owningTeam?.teamId
            }
            target="_blank"
            rel="noreferrer"
            style={{ color: '#7289DA', textDecoration: 'none' }}
          >
            {decodeHtmlEntities(player.owningTeam?.teamName)}
          </a>
          {player.owningTeam?.ownerId && (
            <a
              href={`https://hattrick.org/goto.ashx?path=/MyHattrick/Inbox/?actionType=newMail&userId=${player.owningTeam.ownerId}`}
              target="_blank"
              rel="noreferrer"
              title={player.owningTeam?.loginName || ''}
              style={{
                color: '#7289DA',
                textDecoration: 'none',
                fontSize: '0.85rem',
              }}
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </a>
          )}
          {player.arrivalDate && (
            <span style={{ color: '#aaa' }}>
              {t('since')}{' '}
              {new Date(player.arrivalDate).toLocaleDateString('fi-FI')}
            </span>
          )}
          {visibleLists.length > 0 && (
            <>
              <span style={{ color: '#555' }}>-</span>
              {visibleLists.map((list, idx) => {
                const label =
                  list.Competition && list.Season
                    ? `${list.Competition}${list.Season}${
                        list.Position ? ' ' + list.Position : ''
                      }`
                    : list.Name
                return (
                  <React.Fragment key={list.id || list._id || idx}>
                    <span
                      onClick={() => navigate('/lists')}
                      style={{
                        color: '#7289DA',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                      title={list.Name}
                    >
                      {label}
                    </span>
                    {idx < visibleLists.length - 1 && (
                      <span style={{ color: '#555' }}>-</span>
                    )}
                  </React.Fragment>
                )
              })}
              {remainingCount > 0 && (
                <>
                  <span style={{ color: '#555' }}>-</span>
                  <span style={{ color: '#aaa', fontSize: '0.8rem' }}>
                    {t('and') || 'ja'} {remainingCount} {t('andMoreLists')}
                  </span>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Right side: Last updated + message */}
      <div
        style={{
          textAlign: 'right',
          fontSize: '0.8rem',
          flexShrink: 0,
          alignSelf: 'stretch',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <span style={{ color: '#aaa' }}>{t('lastUpdated')}:</span>
          <br />
          <span
            style={{
              color: isOld(player.dateUpdated) ? '#e74c3c' : '#43B581',
              fontWeight: 'bold',
            }}
          >
            {dateFin(player.dateUpdated)}
          </span>
        </div>
        {message && (
          <div
            style={{
              color: '#43B581',
              fontSize: '0.8rem',
              fontWeight: 'bold',
              marginTop: '4px',
            }}
          >
            {message}
          </div>
        )}
      </div>
    </Card.Header>
  )
}

export default PlayerCardHeader
